<template>
    <div :class="$style.root">
        <a-spin :spinning="spinning">
            <div class="spin-content">
                <div v-if="hotVideoList.length>0">
                    <div
                        class="text-list"
                        @click="goVideoDetail(item.media_id)"
                        v-for="(item, index) in hotVideoList.slice(0,12)"
                        :key="index">
                        <i class="icon" :class="{'panking':index==0||index==1||index==2}">{{ index+1 }}</i>{{ item.media_name }}
                    </div>

                </div>
                <div style="text-align:center;" v-else>暂无内容</div>
            </div>
        </a-spin>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    // import newVideoView from './newVideoView.vue';

    export default {
        name: 'NewTextView',
        // components: { newVideoView },
        data() {
            return {
                spinning: true,
            };
        },
        computed: {
            ...mapState(['userInfo']),
            ...mapState('indexView', ['hotVideoList']),
        },
        mounted() {
            this.handleLoadList();
        },

        methods: {
            ...mapActions('indexView', ['getHotVideoList']),
            ...mapActions('params', [
                'storageLiveParams',
            ]),
            // 加载列表
            handleLoadList() {
                let queries = {};
                // const  = this;
                const orgId = this.userInfo.org_id || '';

                queries = {
                    orgId: orgId || '',
                    orderType: '2',
                };
                if (!this.userInfo.user_name) {
                    delete queries.orgId;
                }
                this
                    .getHotVideoList(queries)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                        this.spinning = false;
                    });
            },

            goVideoDetail(mediaId) {
                this.storageLiveParams({ mediaId });

                this.$router.push({ name: 'VideoDetailView', params: { mediaId } });
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        :global {
            .text-list {
                height: 36px;
                line-height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                white-space: nowrap;

                .icon {
                    width: 22px;
                    height: 22px;
                    line-height: 22px;
                    margin-right: 16px;
                    display: inline-block;
                    text-align: center;
                }

                &:hover {
                    background: #f0f3f9;
                }

                .panking {
                    background: #fcb322;
                }
            }
        }
    }
</style>
